import { TelephonyQueryParams } from '../services/telephony/telephony-queryparams.state.models';
import { AssessmentType } from './../services/interview/interview.model';
import { INotification } from './notifications';
import { ProductAvailability } from './product';

export enum ProductCategoryNames {
    Medicaid = 'medicaid',
    SNAP = 'snap',
    LIS = 'lis',
    Community = 'community',
    VA = 'va',
    SSI = 'ssi'
}

export enum MedicaidType {
    Partial = 'P',
    Full = 'F'
}


export const EnrollmentStages: string[] = ['AwaitingInterview', 'PreparingApplication', 'InProgress'];
export const InterviewInProgressStages: string[] = ['PreparingApplication', 'InProgress'];

// tslint:disable-next-line: no-empty-interface
export interface IAdvanceStageResult {

}

export const ProductCategoryList = Object.getOwnPropertyNames(ProductCategoryNames).map(prop => ProductCategoryNames[prop]);



export class CaseViewModel {
    active: boolean;
    caseId: string;
    externalId: string;
    customMetadata: any;
    currentStage: string;
    currentStageMetadata: any;
    productId: string;
    productName: string;
    productDescription: string;
    currentStageCreatedOn?: Date;
    productCategoryId: string;
    productCategoryName: string;
    owner: string;
    ownerSetBy: string;

    stages: ICaseStageEnum[];
    sortedAvailableStages: ICaseStageEnum[];
    currentStageAssessmentType: AssessmentType;
    currentStageCompletion: number;

    constructor(input?: Partial<CaseViewModel>) {
        if (!input) {
            return;
        }

        const internal = JSON.parse(JSON.stringify((input || {}))) as CaseViewModel;


        Object.assign(this, internal);

        this.stages = internal.stages;

        const sort = (item1, item2) => {
            return item1.order < item2.order ? -1 : (item1.order > item2.order ? 1 : 0);
        };

        this.sortedAvailableStages = this.stages && this.stages.sort(sort);

        this.currentStageAssessmentType = internal.currentStageAssessmentType as AssessmentType;


        this.setCurrentStage(internal.currentStage, internal.currentStageMetadata, (internal as any).currentStageStatus);
    }

    setCurrentStage(stageId: string, metadata: any, status: any = null) {
        this.currentStage = stageId;
        this.currentStageMetadata = metadata;

        if (status) {
            if (status.progress) {
                const progress = status.progress;
                this.currentStageCompletion = progress && progress.completion as number;
                if (this.currentStageCompletion) {
                    this.currentStageCompletion = Math.round(Math.abs(this.currentStageCompletion));
                }
            }
        }
    }

}


export interface ICaseStageEnum {
    id: string;
    description: string;
    order: number;
    disableManual: boolean;
    data?: CaseStageViewModel[];
    allowedRollbackCaseStages: string[];
}

export class CaseStageViewModel {
    metadata?: any;
}


export interface IHistoricItem {
    id: string;
    metaData: any;
    createdOn?: Date;
    status?: string;
}

export class RollbackCaseStageRequestData {
    tenantId: string;
    caseId: number;
    stageFrom: string;
    stageTo: string;
    userId: string;
    reason: string;

    constructor(tenantId: string, caseId: string, stageFrom: string, stageTo: string, userId: string, reason: string) {
        this.tenantId = tenantId;
        this.caseId = caseId as unknown as number;
        this.stageFrom = stageFrom;
        this.stageTo = stageTo;
        this.userId = userId;
        this.reason = reason;
    }
}

export class AssignCaseOwnershipRequest {
    tenantId: string;
    caseIds: string[];
    owner: string;
    user: string;
    memberId: string;
    ownerObjectId: string;

    constructor(input: Partial<AssignCaseOwnershipRequest>) {
        Object.assign(this, input);
    }
}

export interface IProductCategoryAvailability {
    available: boolean;
    availabilityReason: ProductAvailability;
    stageDisplayName: string;
}
// --------------------------------------- Case ------------------------------------------------------------------------------

export interface ITimelineCaseModel {
    caseId?: string;
    tenantId: string;
    entityTypeName?: string;
    externalId?: string;
    entityTypeId?: number;
    productName?: string;
    entryStatus?: string;
    productCategoryName?: string;
    stageMetadata?: any;
    ownerMetadata?: any;
    metadata?: any;
    stage?: string;
    stageFrom?: string;
    stageCreatedOn?: Date;
    createdOn?: Date,
    owner?: string;
    ownerSetBy?: string;
    ownerSetOn?: Date;
    configuration?: string;
    context?: string;
}

export interface ITimelinePreviousCaseEvent {
    productCase: ITimelineCaseModel;
}

export interface ITimelineFilterData {
    entityId: string;
    entityType: string;
    title: string;
    entityIcon: string;
    uiComponent: string;
    createdOn: Date;
    entityInfo: any;
    showDetails?: boolean;
    showRawData?: boolean;
}


// ---------------------------------- New case context Begin -----------------------------------------------------


export declare type MatchingCaseFunc = (item: IProductContextCase, context: { [key: string]: any }) => boolean;


export interface ICurrentCaseByCategory {
    role: string;
    user: string;
    memberId: string;
    productCategoryName: string;
    telephonyQueryParams: TelephonyQueryParams;
    tenantId: string;
}

export interface IProductCategoryContext {
    cases: IProductContextCase[];
    noCaseMessage: string;
    owner: IProductContextMetadataOwner;
    categoryName: string;
    categoryDisplayName: string;
    productActive: boolean;
    disabledReason: string;
    icon: string;
    notifications: INotification[];
    stages: IProductStage[];
    product: any;
    status: IProductContextCaseStatus;
    metadata: any | IProductCategoryMetadata;
    currentStageIsLast(): boolean;
    caseCreateProductType?: string;
}


export interface IProductCategoryMetadata {
    interviews: IProductInterviewConfig[];
}

export interface IProductInterviewConfig {
    type: string;
    packageName: string;
    packageVersion: string;
    entityType: string;
    completion: number;
}

export interface IProductContextCase {
    id: string,
    createdOn: Date;
    externalId: string,
    productId: string;
    productName: string;
    customData: any;
    stage: IProductContextCurrentStage;
    metadata: any;
}

export interface IProductExclusion {
   exclusionType : string;
   productCategoryName: string;
   reasonCode : string;
   reasonDescription : string;
   severity : string;
   icon : string;
}

export interface IProductContextCaseStatus {
    name: string;
    active: boolean;
    displayName: string;
    exclusions: IProductExclusion[];
}

export interface IProductContextCurrentStage {
    destination: string;
    source: string;
    assessment: IProductContextAssessmentStatus;
    createdOn: Date
    metadata: any;
}

export interface IProductContextAssessmentStatus {
    evaluationStatus: string;
    resultTime: Date;
    completion: number;
    evaluationSeverityMode: string;
    hasEvaluationErrors: boolean;
}

export interface IProductContextAssessmentStatusProgress {
    completion: number;
    lastUpdatingUser: string;
}


export interface IProductContextMetadataOwner {
    name: string;
    createdOn: Date;
    assigner: string;
    ownerObjectId?: string;
}

export interface IProductStage {
    name: string;
    description: string;
    assessmentType: string;
    displayName: string;
    rollbackTargets: string[];
    order: number;
    metadata: any;
    // local use
    createdOn?: Date;
    source: string;
    destination: string;
}

export interface IProductSmartActionReference {
    id: string;
    icon: string;
    label: string;
    order: number;
    tooltip: string;
    confirmation: {
        title: string;
        details: string;
    }
    command: string;
    context: any;
    disabled: boolean;
    separator: boolean;
}


// ---------------------------------- New case context End -----------------------------------------------------
